<template>
    <section
      id="desktop-app"
      class="cta-image-area_one section-space--ptb_120"
      aria-labelledby="desktop-app-title"
      data-analytics-section="desktop_app"
      data-analytics-section-name="Desktop app"
    >
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="cta-image cta-image-bg bg-cover">
                        <div class="row align-items-center">
                            <div class="col-lg-6 order-2 order-lg-1">
                                <div class="cta-image__content">
                                    <p class="cta-image__eyebrow">The local half of the workflow</p>
                                    <h2 id="desktop-app-title" class="cta-image__title text-white mb-20">Your After Effects machine, connected.</h2>
                                    <p class="cta-image__text text-white mb-25">The free desktop app syncs templates and handles browser preview and render requests.</p>
                                    <router-link to="/downloads" class="btn btn--green" data-analytics-id="desktop_app_download">
                                        <span class="btn-icon ml-0 mr-2"><i class="fa fa-arrow-alt-to-bottom"></i></span> Download the desktop app
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-lg-6 order-1 order-lg-2">
                                <div class="cta-image__media">
                                    <img src="../assets/img/banners/desktop-app.png" class="img-fluid" width="685" height="465" loading="lazy" decoding="async" alt="MoDeck desktop app showing synced templates and render controls">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'CtaOne',
    }
</script>

<style scoped>
.cta-image__eyebrow {
  margin-bottom: 13px;
  color: #68c0ce;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.cta-image__title {
  max-width: 520px;
  font-size: clamp(30px, 3vw, 46px);
  font-weight: 400;
  letter-spacing: -0.025em;
  line-height: 1.2;
}

.cta-image__text {
  max-width: 560px;
  color: rgba(255, 255, 255, 0.82) !important;
  line-height: 1.75;
}

@media (max-width: 575px) {
  .cta-image__content {
    padding-left: 24px !important;
    padding-right: 24px;
  }

  .cta-image__title {
    font-size: 31px;
  }
}
</style>
